export const GET_SECTIONS = 'GET_SECTIONS'
